(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.menu-button').forEach((button)=>{button.addEventListener('click',()=>{const nav=document.getElementById(button.getAttribute('aria-controls'));const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open)})});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repair-request"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('#Handoff').forEach((handoff)=>{const fields=document.getElementById('PickupFields');const date=document.getElementById('PickupDate');const slot=document.getElementById('PickupSlot');date.min=new Date().toISOString().split('T')[0];const update=()=>{const pickup=handoff.value==='Pickup';fields.hidden=!pickup;date.required=pickup;slot.required=pickup};handoff.addEventListener('change',update);update()});
  } catch(e) { console.error(e); }
})();
})();
